var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticStyle:{"min-width":"36px","padding":"0px 0px 0px 0px"},attrs:{"text":"","ripple":false},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"color":`rgba(200, 200, 200, ${_vm.field === _vm.currentField ? '1' : '0.2'})`}},[_vm._v(_vm._s(_vm.iconClass))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }